import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  ResourceContextProvider,
  sanitizeListRestProps,
  SearchInput,
  SelectInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import PostBatchInvoiceButton from "./components/PostBatchInvoiceButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";

const ThisFilter = (props: any) => {
  return (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
      <ReferenceInput
        label="Academic Year"
        source="AcademicYearId"
        reference="academicYears"
        filter={{
          SchoolId: Number(props.filterValues.SchoolId),
        }}
        alwaysOn
      >
        <SelectInput optionText="name" optionId="id" />
      </ReferenceInput>
    </Filter>
  );
};

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/ratecharts/create?source=${JSON.stringify({
              schoolId: Number(props.filterValues?.SchoolId),
            })}&schoolId=${Number(props.filterValues?.SchoolId)}`
          )
        }
        label="Create Rate Chart"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const Pricing = (props: ShowProps) => {
  const EditPricingButton = ({ id }: any) => {
    return (
      <Button
        href={`/#/rateCharts/${id}?schoolId=${props.id}`}
        color="primary"
        label="Edit"
        style={{ backgroundColor: "#ff9800" }}
      >
        <EditIcon />
      </Button>
    );
  };

  const ShowPricingButton = ({ id }: any) => {
    return (
      <Button
        href={`/#/rateCharts/${id}/show?schoolId=${props.id}`}
        color="primary"
        label="Show"
      >
        <VisibilityIcon />
      </Button>
    );
  };

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Rate Charts</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="rateCharts">
          <List
            {...props}
            exporter={false}
            hasCreate={false}
            filterDefaultValues={{ SchoolId: Number(props.id) }}
            filters={<ThisFilter />}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
          >
            <Datagrid>
              <TextField source="name" label="Chart Name" />
              <ReferenceField
                source="academicYearId"
                reference="academicYears"
                label="Academic Year"
                emptyText="-"
              >
                <TextField source="name" />
              </ReferenceField>
              <CustomDateField
                source="invoiceIssuedAt"
                label="Invoice Issued At"
                emptyText="-"
              />
              <CustomDateField
                source="startedAt"
                label="Pricing Start At"
                emptyText="-"
              />
              <CustomDateField
                source="endedAt"
                label="Pricing End At"
                emptyText="-"
              />
              <StatusField source="status" />
              <FunctionField
                label="Action"
                render={(record: any) => {
                  return (
                    <>
                      <ShowPricingButton id={record.id} />
                      {record.status === "issued" &&
                        localStorage
                          .getItem("roles")
                          .includes("superadmin") && (
                          <PostBatchInvoiceButton rateChartId={record.id} />
                        )}
                      {record.status === "active" && (
                        <EditPricingButton id={record.id} />
                      )}
                    </>
                  );
                }}
              />
            </Datagrid>
          </List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default Pricing;
